import { AtMentionsViewState } from '../store/schema/AtMentionsViewState';
import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';
import { action } from 'satcheljs/lib/legacy';

export default action('addMentionAddedRecipient')(function addMentionAddedRecipient(
    viewState: AtMentionsViewState,
    recipient: FindRecipientPersonaType
) {
    viewState.mentionsAddedRecipients.push(recipient.EmailAddress.EmailAddress);
});
